import React, { useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import type { FeatureCollection } from 'geojson';

const SRC  = 'aviplan-swept-paths-src';
const FILL = 'aviplan-sp-fill';
const LINE = 'aviplan-sp-line';

const EMPTY: FeatureCollection = { type: 'FeatureCollection', features: [] };

const SweptPathLayer: React.FC<{
  map: mapboxgl.Map;
  data: FeatureCollection | null;
  visible: boolean;
}> = ({ map, data, visible }) => {

  // Init source + layers on mount
  useEffect(() => {
    if (map.getSource(SRC)) return;

    map.addSource(SRC, { type: 'geojson', data: EMPTY });

    map.addLayer({
      id: FILL, type: 'fill', source: SRC,
      paint: { 'fill-color': '#29B6F6', 'fill-opacity': 0.18 },
    });
    map.addLayer({
      id: LINE, type: 'line', source: SRC,
      paint: {
        'line-color': '#29B6F6',
        'line-width': 1.5,
        'line-dasharray': [3, 2],
      },
    });
  }, [map]);

  // Sync data
  useEffect(() => {
    const src = map.getSource(SRC) as mapboxgl.GeoJSONSource | undefined;
    src?.setData(data ?? EMPTY);
  }, [data, map]);

  // Sync visibility
  useEffect(() => {
    const vis = visible ? 'visible' : 'none';
    if (map.getLayer(FILL)) map.setLayoutProperty(FILL, 'visibility', vis);
    if (map.getLayer(LINE)) map.setLayoutProperty(LINE, 'visibility', vis);
  }, [visible, map]);

  return null;
};

export default SweptPathLayer;
